import { useHistory, useLocation } from "react-router-dom";
import { VStack } from "@chakra-ui/react";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";

import { SideDrawerLink } from "./SideDrawerLink";

interface IProps {
  onCloseDrawer: () => void;
}

const MobileProtectedRoutes = ({ onCloseDrawer }: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();
  const { pathname } = useLocation();
  const { push } = useHistory();

  return (
    <VStack spacing={4} alignItems="baseline">
      <SideDrawerLink
        onClick={() => {
          onCloseDrawer();
          push(`/e-rezerwacja/${friendlyUrl}`);
        }}
      >
        <ChakraText>Strona główna</ChakraText>
      </SideDrawerLink>
      {getProtectedRoutes(friendlyUrl).map((route, index) => {
        const isDisabled = pathname.includes(route.location);
        return (
          <SideDrawerLink
            key={index}
            isDisabled={isDisabled}
            onClick={() => {
              !isDisabled && onCloseDrawer();
              push(route.location);
            }}
          >
            <ChakraText>{route.name}</ChakraText>
          </SideDrawerLink>
        );
      })}
    </VStack>
  );
};

const getProtectedRoutes = (friendlyUrl: string) => {
  const prefix = `/e-rezerwacja/${friendlyUrl}/uzytkownik`;

  return [
    { location: `${prefix}/profil`, name: "Profil użytkownika" },
    { location: `${prefix}/aktualne-wizyty`, name: "Aktualne wizyty" },
    { location: `${prefix}/historyczne-wizyty`, name: "Historyczne wizyty" },
  ];
};

export { MobileProtectedRoutes };
